import styled, { css } from 'styled-components';
import Text from './Text';
export var cssVisuallyHidden = css(["&:not(:focus):not(:active){clip:rect(0 0 0 0);clip-path:inset(50%);height:1px;overflow:hidden;position:absolute;white-space:nowrap;width:1px;}"]);
var VisuallyHidden = styled(Text).attrs(function (_ref) {
  var _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'span' : _ref$as;
  return {
    as: as
  };
}).withConfig({
  displayName: "VisuallyHidden",
  componentId: "sc-z9bhi9-0"
})(["", ""], cssVisuallyHidden);
export default VisuallyHidden;